import React from "react";
export default function Banner({Bnanerimage, image_alt, image_title}) {
  
  return (
    <>

 <div className="banner-wrap">
    <div  className="banner-bg"  style={{ backgroundImage: `url(${Bnanerimage})`, }} >
        <div className="banner-overlay"></div>
        <div className="banner-top-line"></div>
        <div className="banner-content">
          <h1>{image_title}</h1>
          <nav className="breadcrumb-bar" aria-label="breadcrumb">
            <a href="/">Home</a>
            <span className="sep">›</span>
            <span className="current">{image_title}</span>
          </nav>
        </div>
      </div>
      <div className="banner-bottom-line"></div>
    </div>

    </>
  );
}
